import React, { memo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

export type DeleteCommentModalResult = 'cancel' | 'delete'

function DeleteCommentModal() {
  const intl = useIntl()
  const modalElement = useModalElementContext<DeleteCommentModalResult>()

  const handlePrimaryClick = useCallback(() => {
    modalElement.resolve('delete')
  }, [modalElement])

  const handleSecondaryClick = useCallback(() => {
    modalElement.resolve('cancel')
  }, [modalElement])

  return (
    <Modal
      title={intl.formatMessage({ id: 'jrcR1gLX_uSb_96rZhLQ', defaultMessage: 'Delete this comment?', description: 'Modal title for deleting a comment in the shopping cart' })}
      primaryActionText={intl.formatMessage({ id: 'Axf8T1DGING8-HfFCZpL', defaultMessage: 'Delete', description: 'Primary action button to confirm deleting a comment' })}
      secondaryActionText={intl.formatMessage({ id: 'u8HM-JYjCMg2SEJOSEJ7', defaultMessage: 'Cancel', description: 'Secondary action button to cancel deleting a comment' })}
      onPrimaryActionClick={handlePrimaryClick}
      onSecondaryActionClick={handleSecondaryClick}
    >
      <BodyText variant="large">
        {intl.formatMessage({ id: 'G4MyueLv_NvmruY3H8C6', defaultMessage: 'Deleting this comment will remove it for all users. This action cannot be undone.', description: 'Warning notification message when deleting a comment' })}
      </BodyText>
    </Modal>
  )
}

export default memo(DeleteCommentModal)
